export var getOrderedLocations = function getOrderedLocations(filteredApiData) {
  return filteredApiData.sort(function (a, b) {
    return a.name > b.name ? 1 : -1;
  });
};
export var buildGoogleDirections = function buildGoogleDirections(destinationAddress, originAddress) {
  var origin = originAddress ? "&origin=".concat(originAddress) : '';
  var destination = "&destination=".concat(destinationAddress.line1 ? destinationAddress.line1 : '', ",%20").concat(destinationAddress.line2 ? destinationAddress.line2 : '', ",%20").concat(destinationAddress.city ? destinationAddress.city : '', ",%20").concat(destinationAddress.region ? destinationAddress.region : '');
  return "https://www.google.com/maps/dir/?api=1".concat(origin).concat(destination);
};